import React from "react";
import { SvgIcon } from '@material-ui/core';
import clsx from 'clsx';
import { withStyles } from '@material-ui/styles';

const styles = theme => ({
  root: {
    width: 16,
    height: 16,
    fill: "transparent"
  }
});

class IcSmallPhone extends React.Component {

  render() {
    const { classes, className } = this.props;

    return <SvgIcon className = { clsx(classes.root, className) }
                    viewBox = { "0 0 16 16" } >
      <path d="M14.6667 11.2802V13.2802C14.6674 13.4659 14.6294 13.6497 14.555 13.8198C14.4806 13.9899 14.3715 14.1426 14.2347 14.2681C14.0979 14.3937 13.9364 14.4892 13.7605 14.5487C13.5846 14.6082 13.3983 14.6303 13.2133 14.6136C11.1619 14.3907 9.19134 13.6897 7.46001 12.5669C5.84923 11.5433 4.48356 10.1777 3.46001 8.56689C2.33333 6.8277 1.63217 4.84756 1.41334 2.78689C1.39668 2.60254 1.41859 2.41673 1.47767 2.24131C1.53676 2.06589 1.63172 1.90469 1.75652 1.76797C1.88131 1.63126 2.03321 1.52203 2.20253 1.44724C2.37186 1.37245 2.5549 1.33374 2.74001 1.33356H4.74001C5.06354 1.33038 5.3772 1.44495 5.62251 1.65592C5.86783 1.86689 6.02806 2.15986 6.07334 2.48023C6.15775 3.12027 6.31431 3.74871 6.54001 4.35356C6.6297 4.59218 6.64911 4.8515 6.59594 5.10081C6.54277 5.35012 6.41925 5.57897 6.24001 5.76023L5.39334 6.60689C6.34238 8.27592 7.72431 9.65786 9.39334 10.6069L10.24 9.76023C10.4213 9.58099 10.6501 9.45746 10.8994 9.40429C11.1487 9.35112 11.4081 9.37053 11.6467 9.46023C12.2515 9.68593 12.88 9.84248 13.52 9.92689C13.8439 9.97258 14.1396 10.1357 14.351 10.3852C14.5624 10.6347 14.6748 10.9533 14.6667 11.2802Z" stroke="#858585" strokeLinecap="round" strokeLinejoin="round"/>
    </SvgIcon>
  }
}

export default withStyles(styles)(IcSmallPhone);
